const IconImage = {
  dis_op01: require('./icon_disadvantage/icon_disadvantage_01operater.png').default,
};

export default IconImage;
